module.exports = __webpack_public_path__ + "img/facebook_logo.f965b658.svg";